(() => {
  const VERSION = "2026-09-01.2";
  const SEARCH_PATH = "/search";
  const ORIGINAL_QUERY_PARAM = "mpla_q";
  const STOP_WORDS = new Set([
    "a",
    "an",
    "and",
    "apple",
    "computer",
    "computers",
    "for",
    "inch",
    "inches",
    "laptop",
    "laptops",
    "the",
    "with",
  ]);

  const normalizeToken = (token) => {
    const aliases = {
      grey: "gray",
      gig: "gb",
      gigs: "gb",
      terabyte: "tb",
      terabytes: "tb",
    };

    return aliases[token] || token;
  };

  const tokenize = (query) =>
    query
      .toLowerCase()
      .replace(/[“”‘’]/g, "")
      .match(/[a-z0-9]+(?:\.[0-9]+)?/g)
      ?.map(normalizeToken)
      .filter((token) => token.length > 0 && !STOP_WORDS.has(token)) || [];

  const escapeSearchValue = (value) =>
    value.replace(/\\/g, "\\\\").replace(/"/g, '\\"');

  const buildStrictQuery = (query) => {
    const tokens = [...new Set(tokenize(query))].slice(0, 12);
    if (!tokens.length) return query.trim();

    return tokens
      .map((token) => `title:"${escapeSearchValue(token)}"`)
      .join(" AND ");
  };

  const isSearchForm = (form) => {
    if (!(form instanceof HTMLFormElement)) return false;

    const action = new URL(form.action || window.location.href, window.location.origin);
    return action.pathname.endsWith(SEARCH_PATH) && Boolean(form.querySelector('input[name="q"]'));
  };

  const navigateToStrictSearch = (form) => {
    if (!isSearchForm(form) || form.dataset.mplaSearchSubmitting === "true") return false;
    const input = form.querySelector('input[name="q"]');
    const originalQuery = input.value.trim();
    if (!originalQuery) return false;

    const action = new URL(form.action || SEARCH_PATH, window.location.origin);
    const params = new URLSearchParams(new FormData(form));
    params.set("q", buildStrictQuery(originalQuery));
    params.set(ORIGINAL_QUERY_PARAM, originalQuery);
    params.set("type", "product");

    form.dataset.mplaSearchSubmitting = "true";
    window.location.assign(`${action.pathname}?${params.toString()}`);
    return true;
  };

  const stopAndNavigate = (event, form) => {
    if (!navigateToStrictSearch(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  };

  const submitStrictSearch = (event) => {
    stopAndNavigate(event, event.target);
  };

  const clickStrictSearch = (event) => {
    const submitter = event.target.closest(
      'button[type="submit"], input[type="submit"], button:not([type])',
    );
    if (!submitter?.form) return;
    stopAndNavigate(event, submitter.form);
  };

  const enterStrictSearch = (event) => {
    if (event.key !== "Enter" || event.isComposing) return;
    const input = event.target.closest('input[name="q"]');
    if (!input?.form) return;
    stopAndNavigate(event, input.form);
  };

  const replaceText = (root, strictQuery, originalQuery) => {
    if (!root || !strictQuery || strictQuery === originalQuery) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);

    textNodes.forEach((node) => {
      if (node.nodeValue?.includes(strictQuery)) {
        node.nodeValue = node.nodeValue.replaceAll(strictQuery, originalQuery);
      }
    });
  };

  const restoreFriendlyQuery = () => {
    const params = new URLSearchParams(window.location.search);
    const originalQuery = params.get(ORIGINAL_QUERY_PARAM)?.trim();
    const strictQuery = params.get("q")?.trim();
    if (!originalQuery) return;

    document.querySelectorAll('form[action*="/search"] input[name="q"]').forEach((input) => {
      input.value = originalQuery;
    });

    document
      .querySelectorAll('[id^="SearchSection"], main')
      .forEach((root) => replaceText(root, strictQuery, originalQuery));
  };

  window.MPLA_STRICT_SEARCH_VERSION = VERSION;
  document.addEventListener("submit", submitStrictSearch, true);
  document.addEventListener("click", clickStrictSearch, true);
  document.addEventListener("keydown", enterStrictSearch, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", restoreFriendlyQuery, { once: true });
  } else {
    restoreFriendlyQuery();
  }
})();